import Navigation from '../components/layout/Navigation';
import { FileText } from 'lucide-react';
import { isIOS } from '../services/platform.service';

export default function TermsAndConditions() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 via-white to-purple-50">
      <Navigation />
      
      <main className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        {/* Header */}
        <div className="text-center mb-12">
          <div className="inline-flex items-center justify-center w-16 h-16 bg-blue-100 rounded-2xl mb-4">
            <FileText className="w-8 h-8 text-blue-600" />
          </div>
          <h1 className="text-4xl md:text-5xl font-extrabold text-gray-900 mb-4">
            Termeni și Condiții
          </h1>
          <p className="text-lg text-gray-600">
            Data intrării în vigoare: 19 februarie 2026
          </p>
        </div>

        {/* Content */}
        <div className="bg-white rounded-2xl shadow-lg p-8 md:p-12 border-2 border-gray-100">
          <div className="prose prose-lg max-w-none">

            <div className="p-6 bg-blue-50 border-2 border-blue-200 rounded-xl mb-8">
              <p className="text-base text-gray-800 mb-0">
                <strong>PREAMBUL:</strong> Acești Termeni și Condiții ("Termenii") guvernează utilizarea de către dumneavoastră a aplicației mobile FII FIT ("Aplicația"), o platformă software bazată pe inteligență artificială (IA) destinată persoanelor sănătoase și celor cu afecțiuni cronice. Aplicația este dezvoltată și operată de SC GONGA SHOP SRL, o societate comercială înregistrată în România ("Compania", "noi"). Prin descărcarea, instalarea, accesarea sau utilizarea Aplicației, dumneavoastră ("Utilizatorul", "dumneavoastră") confirmați că ați citit, înțeles și sunteți de acord să respectați în totalitate acești Termeni. Dacă nu sunteți de acord cu acești Termeni, nu trebuie să utilizați Aplicația.
              </p>
            </div>

            <h2>1. Acceptarea și Descrierea Serviciilor</h2>

            <h3>1.1. Acceptarea</h3>
            <p>
              Utilizarea Aplicației, {isIOS() ? 'disponibilă în App Store,' : 'disponibilă pe platformele iOS și Android,'} constituie un acord legal obligatoriu între dumneavoastră și Companie. Acest acord include și Politica de Confidențialitate, care este încorporată prin referință în acești Termeni.
            </p>

            <h3>1.2. Descrierea Serviciilor</h3>
            <p>
              FII FIT este o aplicație medicală personalizată care utilizează algoritmi de inteligență artificială pentru a oferi suport în gestionarea sănătății, cu un accent special pe bolile cronice și autoimune. Serviciile includ, dar nu se limitează la:
            </p>
            <ul>
              <li>Crearea unui profil medical personalizat pe baza datelor introduse de utilizator.</li>
              <li>Recomandări adaptate privind nutriția și planuri alimentare.</li>
              <li>Sugestii de exerciții fizice specializate și programe de mișcare.</li>
              <li>Suport informațional 24/7 prin intermediul unui asistent virtual bazat pe IA.</li>
              <li>Monitorizarea și vizualizarea progresului în gestionarea stării de sănătate.</li>
            </ul>

            <div className="p-4 bg-amber-50 border-2 border-amber-300 rounded-xl my-6">
              <p className="text-base text-gray-800 mb-0">
                <strong>⚠️ IMPORTANT:</strong> Aplicația FII FIT este un instrument de suport și informare și <strong>NU înlocuiește consultul medical profesionist, diagnosticul sau tratamentul</strong>. Recomandările generate de IA sunt de natură informativă și trebuie validate întotdeauna cu un medic specialist.
              </p>
            </div>

            <h2>2. Conturi de Utilizator</h2>

            <h3>2.1. Înregistrare</h3>
            <p>
              Pentru a utiliza funcționalitățile complete ale Aplicației, este necesară crearea unui cont de utilizator. Vă angajați să furnizați informații exacte, complete și actuale în timpul procesului de înregistrare și să actualizați aceste informații pentru a le menține astfel.
            </p>

            <h3>2.2. Securitatea Contului</h3>
            <p>
              Sunteți singurul responsabil pentru păstrarea confidențialității parolei și a contului dumneavoastră. Sunteți de acord să ne notificați imediat cu privire la orice utilizare neautorizată a contului dumneavoastră sau orice altă încălcare a securității. Compania nu va fi răspunzătoare pentru nicio pierdere sau daună rezultată din nerespectarea de către dumneavoastră a acestei obligații.
            </p>

            <h3>2.3. Responsabilități</h3>
            <p>
              Sunteți responsabil pentru toate activitățile care au loc sub contul dumneavoastră. Utilizarea contului de către o altă persoană este interzisă.
            </p>

            <h2>3. Reguli de Utilizare a Aplicației</h2>

            <h3>3.1. Utilizare Conformă</h3>
            <p>
              Vă angajați să utilizați Aplicația în conformitate cu legile aplicabile și cu acești Termeni. Este interzisă utilizarea Aplicației în orice scop ilegal sau neautorizat.
            </p>

            <h3>3.2. Restricții</h3>
            <p>Nu aveți dreptul să:</p>
            <ul>
              <li>(a) decompilați, dezasamblați sau încercați să derivați codul sursă al Aplicației;</li>
              <li>(b) modificați, adaptați sau creați lucrări derivate bazate pe Aplicație;</li>
              <li>(c) utilizați Aplicația pentru a transmite viruși, malware sau alt cod dăunător;</li>
              <li>(d) încălcați drepturile de proprietate intelectuală ale Companiei sau ale terților;</li>
              <li>(e) utilizați Aplicația într-un mod care ar putea deteriora, dezactiva, supraîncărca sau afecta serverele noastre.</li>
            </ul>

            <h3>3.3. Conformitate cu Platformele</h3>
            <p>
              Utilizarea Aplicației trebuie să respecte și termenii și condițiile impuse de magazinele de aplicații de pe care a fost descărcată {isIOS() ? '(Apple App Store)' : '(Apple App Store și Google Play Store)'}.
            </p>

            <h3>3.4. Conținut generat de utilizatori și comunitate</h3>
            <p>
              Aplicația include funcții de comunitate (postări, rețete, comentarii, mesaje, profil public). Sunteți singurul responsabil pentru conținutul pe care îl publicați. Este strict interzisă publicarea de conținut ilegal, ofensator, discriminatoriu, sexual, violent, care hărțuiește sau amenință alte persoane, care încalcă drepturi de proprietate intelectuală sau care promovează practici periculoase pentru sănătate. Compania aplică o politică de toleranță zero față de conținutul abuziv și față de utilizatorii abuzivi.
            </p>
            <p>
              Fiecare utilizator poate raporta conținut sau utilizatori direct din Aplicație și poate bloca alți utilizatori, caz în care conținutul acestora nu îi va mai fi afișat. Rapoartele sunt analizate în cel mult 24 de ore; conținutul care încalcă acești Termeni este eliminat, iar utilizatorul responsabil poate fi suspendat sau eliminat definitiv. Semnalările pot fi trimise și la office@fiifit.ro.
            </p>
            <h2>4. Recomandările generate de IA: Limitări și Responsabilități</h2>

            <h3>4.1. Natură Informativă</h3>
            <p>
              Recunoașteți și sunteți de acord că serviciile și recomandările furnizate de componenta de inteligență artificială a Aplicației sunt generate algoritmic pe baza datelor furnizate de dumneavoastră. Acestea au un caracter strict informativ și educațional și nu constituie un act medical, un diagnostic sau o recomandare de tratament.
            </p>

            <h3>4.2. Limitări ale IA</h3>
            <p>
              Algoritmii IA au limitări inerente și pot produce informații incomplete, inexacte sau neadecvate pentru situația dumneavoastră specifică (nivel de antrenament, stare de sănătate, obiective). Performanța sistemului depinde în mod direct de calitatea și acuratețea datelor pe care le introduceți.
            </p>

            <h3>4.3. Responsabilitatea Utilizatorului</h3>
            <p>
              Dumneavoastră sunteți singurul responsabil pentru deciziile pe care le luați cu privire la sănătatea dumneavoastră. Este imperativ să consultați un medic calificat sau un alt furnizor de servicii medicale înainte de a începe orice nou tratament, regim alimentar sau program de exerciții și pentru a valida orice informație primită prin intermediul Aplicației.
            </p>

            <h2>5. Confidențialitatea Datelor și Servicii AI Terțe</h2>
            <p>
              Protecția datelor dumneavoastră cu caracter personal, în special a celor medicale, este o prioritate pentru noi. Colectarea, prelucrarea și stocarea datelor se realizează în conformitate cu Regulamentul (UE) 2016/679 (GDPR) și legislația națională. Pentru informații detaliate, vă rugăm să consultați <strong>Politica de Confidențialitate</strong> a Aplicației FII FIT.
            </p>

            <h3>5.1. Utilizarea Serviciului de Inteligență Artificială OpenAI</h3>
            <p>
              Aplicația FII FIT utilizează serviciul de inteligență artificială furnizat de <strong>OpenAI, L.L.C.</strong> (San Francisco, SUA) pentru a genera recomandări personalizate. Prin utilizarea funcționalităților AI ale Aplicației (chat nutriționist, planuri alimentare, exerciții personalizate, chat terapeutic), recunoașteți și acceptați că:
            </p>
            <ul>
              <li>(a) Datele dumneavoastră de sănătate (profil medical, date biometrice, obiective de sănătate, mesaje din chat) vor fi transmise către serverele FII FIT AI pentru procesare;</li>
              <li>(b) FII FIT AI acționează ca persoană împuternicită de operator și nu utilizează datele dumneavoastră pentru antrenarea modelelor AI;</li>
              <li>(c) Datele sunt transmise criptat și păstrate de FII FIT AI pentru maximum 30 de zile;</li>
              <li>(d) Transferul de date către SUA este protejat prin Clauzele Contractuale Standard (SCC) ale Comisiei Europene;</li>
              <li>(e) Puteți refuza sau retrage consimțământul pentru procesarea AI în orice moment, caz în care funcționalitățile AI nu vor fi disponibile.</li>
            </ul>
            <p>
              Înainte de prima utilizare a funcționalităților AI, aplicația va solicita consimțământul dumneavoastră explicit, informându-vă despre datele transmise și destinatarul acestora.
            </p>

            <h2>6. Plăți și Abonamente</h2>

            <h3>6.1. Model de Abonament</h3>
            <p>
              Anumite funcționalități ale Aplicației pot fi disponibile pe bază de abonament plătit. Detaliile privind costurile, perioadele de facturare și serviciile incluse vor fi prezentate clar în cadrul Aplicației înainte de efectuarea oricărei plăți.
            </p>

            <h3>6.2. Facturare și Reînnoire</h3>
            <p>
              Abonamentele se reînnoiesc automat la sfârșitul fiecărei perioade de facturare, cu excepția cazului în care anulați abonamentul înainte de data reînnoirii. Plățile vor fi procesate prin intermediul contului dumneavoastră {isIOS() ? 'Apple App Store' : 'Apple App Store sau Google Play Store'}.
            </p>

            <h3>6.3. Anulare</h3>
            <p>
              Puteți anula abonamentul în orice moment din setările contului dumneavoastră din magazinul de aplicații corespunzător. Anularea va intra în vigoare la sfârșitul perioadei de facturare curente.
            </p>

            <h2>7. Proprietate Intelectuală</h2>
            <p>
              Toate drepturile, titlurile și interesele asupra Aplicației, inclusiv, dar fără a se limita la, software, text, grafică, logo-uri, algoritmi de IA și întregul conținut (colectiv, "Proprietatea Companiei"), sunt și vor rămâne proprietatea exclusivă a Companiei și a licențiatorilor săi. Acești Termeni nu vă acordă niciun drept de a utiliza mărcile comerciale, logo-urile sau alte elemente de branding ale Companiei.
            </p>

            <h2>8. Limitarea Răspunderii</h2>
            <p>
              În măsura maximă permisă de lege, Compania, afiliații, directorii, angajații și agenții săi nu vor fi răspunzători pentru nicio daună indirectă, incidentală, specială, consecvențială sau punitivă, inclusiv, dar fără a se limita la, pierderi de profit, date, utilizare, bunăvoință sau alte pierderi intangibile, rezultate din: (i) accesul sau utilizarea sau incapacitatea de a accesa sau utiliza Aplicația; (ii) orice conduită sau conținut al oricărei terțe părți în cadrul Aplicației; (iii) orice conținut obținut din Aplicație, în special recomandările IA; și (iv) accesul, utilizarea sau alterarea neautorizată a transmisiilor sau conținutului dumneavoastră. Utilizați Aplicația și vă bazați pe informațiile acesteia pe propriul risc.
            </p>

            <h2>9. Modificări și Încetare</h2>

            <h3>9.1. Modificări</h3>
            <p>
              Ne rezervăm dreptul de a modifica acești Termeni în orice moment. În cazul unor modificări substanțiale, vom depune eforturi rezonabile pentru a vă notifica (de exemplu, printr-o notificare în Aplicație sau prin e-mail). Continuarea utilizării Aplicației după intrarea în vigoare a modificărilor constituie acceptarea noilor Termeni.
            </p>

            <h3>9.2. Încetare</h3>
            <p>
              Putem suspenda sau înceta accesul dumneavoastră la Aplicație, fără notificare prealabilă și fără răspundere, din orice motiv, inclusiv în cazul încălcării acestor Termeni. Puteți înceta utilizarea și solicita ștergerea contului în orice moment.
            </p>

            <h2>10. Legea Aplicabilă și Jurisdicția</h2>
            <p>
              Acești Termeni vor fi guvernați și interpretați în conformitate cu legile României, fără a se ține seama de dispozițiile privind conflictul de legi. Orice dispută care decurge din sau în legătură cu acești Termeni va fi supusă jurisdicției exclusive a instanțelor competente din România.
            </p>

            <h2>11. Contact</h2>
            <p>
              Pentru orice întrebări legate de acești Termeni și Condiții, vă rugăm să ne contactați la adresa de e-mail: <a href="mailto:office@fiifit.ro">office@fiifit.ro</a> sau prin intermediul secțiunii de contact din aplicație.
            </p>
            <p className="text-sm text-gray-600 mt-4">
              <strong>SC GONGA SHOP SRL</strong> · CUI: RO40071310 · Str. Nicolae Titulescu 16, Agigea, jud. Constanța, România · Tel: 0787-569.002
            </p>

            <div className="mt-12 p-6 bg-gray-50 border-2 border-gray-200 rounded-xl text-center">
              <p className="text-sm text-gray-600 mb-0">
                © 2026 SC GONGA SHOP SRL. Toate drepturile rezervate. | FII FIT
              </p>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
}
